import React from 'react';
import '../player/EditPlayerScreen.css'
import EditPlayerScreen from '../player/EditPlayerScreen';
import { useParams } from 'react-router-dom';

function Players() {
  const { playerId } = useParams();

  return (
    <React.Fragment>
      <div className={"generalPlayerContainer"}>
        <EditPlayerScreen playerId={playerId} />
      </div>
    </React.Fragment>
  );
}

export default Players;